interface EmptyCandidatesProps {
  includeRejected: boolean;
}

/**
 * Empty state: the crawler ran and produced a dataset with nothing in it —
 * a real signal, and explicitly not the unreachable error state.
 */
export default function EmptyCandidates({ includeRejected }: EmptyCandidatesProps) {
  return (
    <div className="border border-gray-200 rounded-lg bg-white p-6 text-center space-y-1">
      <h2 className="text-sm font-semibold text-gray-800">0 candidates</h2>
      <p className="text-sm text-gray-500">
        {includeRejected
          ? 'The latest run produced no listings at all — qualifying or rejected.'
          : 'Nothing qualifies in the latest run. Toggle "Include rejected" to see what was discarded.'}
      </p>
    </div>
  );
}
